// Data View screen data frame storage
export const setStorageDataFrame = (dataFrame) => {
  localStorage.setItem('dataViewDataFrame', JSON.stringify(dataFrame));
};

export const getStorageDataFrame = () => {
  const item = localStorage.getItem('dataViewDataFrame');
  if (!item || item === 'undefined') {
    return null;
  } else {
    return JSON.parse(item);
  }
};
